import { render, staticRenderFns } from "./TrendAnalysis.vue?vue&type=template&id=634909f7&scoped=true&"
import script from "./TrendAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrendAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrendAnalysis.vue?vue&type=style&index=0&id=634909f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634909f7",
  null
  
)

export default component.exports